const getters = {
    // sidebar: state => state.app.sidebar,
    localShotinfoList: state => state.persistence.localShotinfoList,
}
export default getters